import React, { ReactNode } from 'react';
import SiteFooter from './SiteFooter';

interface PublicPageShellProps {
  children: ReactNode;
}

/**
 * Public pages layout: main content plus footer pinned at bottom on short viewports.
 */
export const PublicPageShell: React.FC<PublicPageShellProps> = ({ children }) => (
  <div className="public-page-shell">
    <main className="public-page-shell-main">{children}</main>
    <SiteFooter />
  </div>
);

export default PublicPageShell;
